import { makeStyles } from "@material-ui/styles";
import MenuImg from "../images/menu-bg.jpg";

const styles = makeStyles((theme) => ({
    subColor: {
		color: "#fff",
		fontFamily: "bariol",
		"&:hover": {
			color: "#000"
		}
	},
	newBrave: {
		fontFamily: "BreveSC !important"
	},
	downArrow: {
		verticalAlign: "middle"
	},
	menuDrop: {
		margin: "0 !important",
		padding: "0px 20px !important",
		"& li": {
			marginTop: "0 !important"
		},
		"& li:hover": {
			color: "#fff"
		}
	},
	headerWrapper: {
		display: "flex",
		justifyContent: "space-between",
		padding: "3% 0 20px 0",
		maxWidth: 1700,
		margin: "auto",
		width: "90%",
		"& span": {
			[theme.breakpoints.down("sm")]: {
				display: "flex"
			}
		},
		[theme.breakpoints.down("sm")]: {
			position: "relative"
		},
		"& a": {
			color: "#000",
			textDecoration: "none",
			marginLeft: 40,
			[theme.breakpoints.down("sm")]: {
				marginLeft: 10
			},
			"& img": {
				display: "none",
				[theme.breakpoints.down("sm")]: {
					display: "block"
				}
			},
			"& .icon": {
				[theme.breakpoints.down("sm")]: {
					display: "none"
				}
			}
		}
	},
	menuIcon: {
		width: 50,
		cursor: "pointer",
		"& span": {
			width: "60%",
			height: 3,
			margin: 5,
			display: "block",
			background: "#000",
			transition: "all 0.8s cubic-bezier(0.810, -0.330, 0.345, 1.375)",
			transitionDelay: "0.2s"
		},
		"& span:nth-child(2n)": {
			marginLeft: 15
		}
	},
	headerlogo: {
		display: "none",
		"& img": {
			[theme.breakpoints.down("sm")]: {
				width: 80
			}
		},
		[theme.breakpoints.down("sm")]: {
			display: "block",
			position: "absolute",
			textAlign: "center",
			left: 0,
			right: 0,
			zIndex: 1,
			top: 0
		}
	},
	drawerRoot: {
		minWidth: 280,
		textAlign: "center",
		backgroundImage: `url(${MenuImg})`,
		display: "flex",
		alignItems: "center",
		padding: "50px 0",
		"& ul": {
			margin: "30px 0 0 0",
			padding: 0,
			"& li": {
				listStyle: "none",
				color: "#fff",
				fontSize: 15,
				textAlign: "left",
				margin: "20px 0",
				cursor: "pointer",
				"&:hover": {
					color: "#000"
				}
			}
		}
	},
	menuImg: {
		background: "#fff",
		width: 150,
		height: 150
	},
	footer: {
		background: "#000"
	},
	wrapper: {
		width: "90%",
		padding: "3% 0 3% 0",
		margin: "auto",
		color: "#fff",
		display: "flex",
		position: "relative",
		justifyContent: "space-between",
		"& .footerLogos": {
			position: "absolute",
			width: 570,
			right: "0",
			top: 0,
			background: "#d2d3d5",
			display: "flex",
			flexDirection: "row",
			height: "auto",
			justifyContent: "space-around",
			[theme.breakpoints.down("sm")]: {
				display: "none"
			}
		},
		"& .footermlogo": {
			display: "flex",
			flexDirection: "column-reverse"
		},
		"& ul": {
			margin: "35px 0 0 0",
			padding: 0,
			"&:nth-child(2)": {
				"& li": {
					borderBottom: "1px solid #fff"
				}
			},
			"& li": {
				listStyle: "none",
				display: "inline-block",
				marginRight: 40,
				"& a": {
					color: "#fff",
					textDecoration: "none"
				},
				[theme.breakpoints.down("sm")]: {
					marginBottom: 20
				}
			}
		}
	}
}));
export default styles;
